import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Link} from 'react-router-dom';
import { ONLINESTATUS } from '../../../utils/questionManageType'
import $ from '$'
import axios from 'axios'
import API  from '@/API/api';
import {deleteCateItemAPI} from '@/API';
import {Button,  Input, Row, Col,message,Modal,Popconfirm,Table} from 'antd';
import {PropTypes} from 'prop-types';
import storage from '../../../utils/cookie'
import {WrappedCreateLabelModalForm} from './modal/create_label'
import {WrappedDeleteLabelModalForm} from './modal/delete_label'
import {WrappedEditItemModalForm} from './modal/edit_item'

class WordBank extends Component{

    state={
        page:1,
        pagesize:50,
        tab:1,
        search:'',
        openCreate:false,
        openDelete:false,
        editDialog:false,
        itemData:{}
    }
    columns = [
        {
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            width:100,
            render: (text, record, index) => (
                <span>{(this.state.page-1)*this.state.pagesize+index+1}</span>
            ),
        },
        {
            title: '字',
            dataIndex: 'word',
            key: 'word',
            width:150,
            render: (text, record, index) => (
                <span>{record.cateitem}</span>
            ),
        },{
            title: '会认',
            dataIndex: 'know',
            width:150,
            render: (text, record, index) => (
                <span>{record.group.some(d=>d==='会认')?'√':''}</span>
            ),
        },{
            title: '会写',
            key: 'read',
            width:150,
            render: (text, record, index) => (
                <span>{record.group.some(d=>d==='会写')?'√':''}</span>
            ),
        }
    ]
    columnsWords = [
        {
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            width:200,
            render: (text, record, index) => (
                <span>{(this.state.page-1)*this.state.pagesize+index+1}</span>
            ),
        },
        {
            title: '词',
            dataIndex: 'word',
            key: 'word',
            width:200,
            render: (text, record, index) => (
                <span>{record.cateitem}</span>
            ),
        }
    ]
    columnsPinyin = [
        {
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            width:200,
            render: (text, record, index) => (
                <span>{(this.state.page-1)*this.state.pagesize+index+1}</span>
            ),
        },
        {
            title: '拼音',
            dataIndex: 'word',
            key: 'word',
            width:200,
            render: (text, record, index) => (
                <span>{record.cateitem}</span>
            ),
        }
    ]
    columnsBiaodian = [
        {
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            width:200,
            render: (text, record, index) => (
                <span>{(this.state.page-1)*this.state.pagesize+index+1}</span>
            ),
        },
        {
            title: '标点',
            dataIndex: 'word',
            key: 'word',
            width:200,
            render: (text, record, index) => (
                <span>{record.cateitem}</span>
            ),
        }
    ]
    columnsEnWords = [
        {
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            width:200,
            render: (text, record, index) => (
                <span>{(this.state.page-1)*this.state.pagesize+index+1}</span>
            ),
        },
        {
            title: '词汇',
            width:200,
            key: 'item',
            render: (text, record, index) => (
                <span>{record.cateitem}</span>
            ),
        },
        {
            title: '操作',
            width:200,
            key: 'action',
            render: (text, record, index) => (
                <span>
                		<Button style={{marginRight:'10px'}} icon="edit" type="primary" onClick={()=>this.handleEditItem(record)}></Button>
                		<Popconfirm
					    title="确定要删除这一条内容吗？"
					    onConfirm={()=>this.handleDeleteItem(record)}
					    okText="确定"
					    cancelText="取消"
					>
                		<Button icon="delete" type="danger" ></Button>
                		</Popconfirm>
                		{record.cateitem&&<Link  style={{marginLeft:'10px'}} to={`/questionmanage/lookoverquestion?cateitem=${record.cateitem}`}>查看题目</Link>}
                </span>
            ),
        },
        
    ]
    columnsSentencePattern = [
        {
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            width:200,
            render: (text, record, index) => (
                <span>{(this.state.page-1)*this.state.pagesize+index+1}</span>
            ),
        },
        {
            title: '句型',
            width:200,
            key:'item',
            render: (text, record, index) => (
                <span>{record.cateitem}</span>
            ),
        },
          {
            title: '操作',
            width:200,
            key: 'action',
            render: (text, record, index) => (
                <span>
                		<Button style={{marginRight:'10px'}} icon="edit" type="primary" onClick={()=>this.handleEditItem(record)}></Button>
                		<Popconfirm
					    title="确定要删除这一条内容吗？"
					    onConfirm={()=>this.handleDeleteItem(record)}
					    okText="确定"
					    cancelText="取消"
					>
                		<Button icon="delete" type="danger" ></Button>
                		</Popconfirm>
                		{record.cateitem&&<Link   style={{marginLeft:'10px'}} to={`/questionmanage/lookoverquestion?cateitem=${record.cateitem}`}>查看题目</Link>}
                </span>
            ),
        },
    ]
    columnsCategoryLabel = [
        {
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            width:200,
            render: (text, record, index) => (
                <span>{(this.state.page-1)*this.state.pagesize+index+1}</span>
            ),
        },
        {
            title: '分类标签',
            width:200,
            render: (text, record, index) => (
                <span>{record.cateitem}</span>
            ),
        }
    ]
    search=()=>{
        this.state.page = 1
        this.setState({page:1})
        this.getList()
    }
    getList=()=>{
        setTimeout(()=>{
            let data = {
                page:this.state.page,
                pagesize:this.state.pagesize,
                type:this.state.tab,
                cateitem:this.state.search,
            }
            axios.post(API.LOOKOVER_WORD_BANK, data).then((res)=>{
                res = res.data;
                if (res.code === 0) {
                    this.setState({data:res.data.list,total:~~res.data.total})
                }else{
                    message.error(res.message);
                }
            },()=>{message.error("网络错误！")})
        },0)
    }

    onPageChange=(val)=>{
        this.state.page = val
        this.setState({page:val})
        this.getList()
        document.querySelector('.questionListScroll').scrollTop=0
    }

    componentDidMount(){
        if(this.props.user.product===7){
            this.setState({tab:3})
            setTimeout(()=>{
                this.getList()
            },0)

        }
    }
    inited= false
    componentDidUpdate(){
        if(this.props.user.product===7&&!this.inited){
            this.inited = true
            this.setState({tab:3})
            setTimeout(()=>{
                this.getList()
            },0)
        }else if(this.props.user.product&&this.props.user.product!=7){
        		this.columnsSentencePattern.pop()
        		this.columnsEnWords.pop()
        }
    }
	handleEditItem(item){
		this.setState({
			itemData:item,
			editDialog:true
		})
	}
	handleDeleteItem(item){
		deleteCateItemAPI({"cateitem_ids":[item.cateitem_id]}).then(res=>{
			message.success('删除成功！');
			this.getList()
		})
	}
    exportExcel = ()=>{
        var form = $("<form>");   //定义一个form表单
        form.attr('style', 'display:none');   //在form表单中添加查询参数
        form.attr('target', '');
        form.attr('method', 'post');
        form.attr('action', API.EXPORT_WORD_BANK);

        var input1 = $('<input>');
        input1.attr('type', 'hidden');
        input1.attr('name', 'type');
        input1.attr('value', this.state.tab);

        form.append(input1);   //将查询参数控件提交到表单上
        $('body').append(form);  //将表单放置在web中
        form.submit();
    }
    handleOpenModal(openType){
    		this.setState({[openType]:true})
    }

    handleClose=()=>{
    		this.setState({openCreate:false,openDelete:false,editDialog:false})
    		this.onPageChange(1)
    }
    render(){
        let data = this.state.data||[]
        let width = 0;
        for(let key in this.columns){
            width += this.columns[key].width;
        }
        this.state.totalWidth=width
        return(
            <div>
                {
                    this.props.user.subject=='1'&&
                    <Button.Group>
                        <Button onClick={()=>{this.setState({tab:1});setTimeout(()=>{this.search()},0)}} type={this.state.tab==1?'primary':''} size={'large'}>字库管理</Button>
                        <Button onClick={()=>{this.setState({tab:2});setTimeout(()=>{this.search()},0)}} type={this.state.tab==2?'primary':''} size={'large'}>词库管理</Button>
                        <Button onClick={()=>{this.setState({tab:5});setTimeout(()=>{this.search()},0)}} type={this.state.tab==5?'primary':''} size={'large'}>拼音管理</Button>
                        <Button onClick={()=>{this.setState({tab:6});setTimeout(()=>{this.search()},0)}} type={this.state.tab==6?'primary':''} size={'large'}>标点管理</Button>
                        <Button onClick={()=>{this.setState({tab:7});setTimeout(()=>{this.search()},0)}} type={this.state.tab==7?'primary':''} size={'large'}>分类标签</Button>
                    </Button.Group>
                }
                {
                    this.props.user.subject=='2'&&
                    <Button.Group>
                        <Button onClick={()=>{this.setState({tab:3});setTimeout(()=>{this.search()},0)}} type={this.state.tab==3?'primary':''} size={'large'}>词汇管理</Button>
                        <Button onClick={()=>{this.setState({tab:4});setTimeout(()=>{this.search()},0)}} type={this.state.tab==4?'primary':''} size={'large'}>句型管理</Button>
                    </Button.Group>
                }

                <Row style={{margin:'20px'}}>
                    <span style={{fontSize:'14px'}}>查询：</span>
                    <Input value={this.state.search} onChange={(e)=>{this.setState({search:e.target.value})}}  style={{width:'200px'}}/>
                    <Button onClick={this.search} style={{marginLeft:'20px'}}>搜索</Button>
                    {this.state.tab===7&&<Button onClick={()=>this.handleOpenModal('openCreate')} type="primary" style={{marginLeft:'20px'}}>添加标签</Button>}
                    {this.state.tab===7&&<Button onClick={()=>this.handleOpenModal('openDelete')} type="danger"  style={{marginLeft:'20px'}}>删除标签</Button>}
                    <Button onClick={this.exportExcel} style={{marginLeft:'150px'}}>导出Excel</Button>
                </Row>

                {
                    this.state.tab===1?
                        <Row style={{maxWidth:this.state.totalWidth + 62,marginTop:20,}}>
                            <Table rowKey={(record)=>record.cateitem_id} columns={this.columns} dataSource={data} pagination={{ pageSize: +this.state.pagesize,total:this.state.total,onChange:this.onPageChange }} loading={this.state.loading} scroll={{ x: this.state.totalWidth + 62 }}/>
                        </Row>
                        :
                        this.state.tab===2?
                        <Row style={{maxWidth:this.state.totalWidth + 62,marginTop:20,}}>
                            <Table rowKey={(record)=>record.cateitem_id} columns={this.columnsWords} dataSource={data} pagination={{ pageSize: +this.state.pagesize,total:this.state.total,onChange:this.onPageChange }} loading={this.state.loading} scroll={{ x: this.state.totalWidth + 62 }}/>
                        </Row>
                            :
                            this.state.tab===3?
                                <Row style={{maxWidth:this.state.totalWidth + 62,marginTop:20,}}>
                                    <Table rowKey={(record)=>record.cateitem_id} columns={this.columnsEnWords} dataSource={data} pagination={{ pageSize: +this.state.pagesize,total:this.state.total,onChange:this.onPageChange }} loading={this.state.loading} scroll={{ x: this.state.totalWidth + 62 }}/>
                                </Row>
                                :
                                this.state.tab===4?
                                    <Row style={{maxWidth:this.state.totalWidth + 62,marginTop:20,}}>
                                        <Table rowKey={(record)=>record.cateitem_id} columns={this.columnsSentencePattern} dataSource={data} pagination={{ pageSize: +this.state.pagesize,total:this.state.total,onChange:this.onPageChange }} loading={this.state.loading} scroll={{ x: this.state.totalWidth + 62 }}/>
                                    </Row>
                                :this.state.tab===5?
                                    <Row style={{maxWidth:this.state.totalWidth + 62,marginTop:20,}}>
                                        <Table rowKey={(record)=>record.cateitem_id} columns={this.columnsPinyin} dataSource={data} pagination={{ pageSize: +this.state.pagesize,total:this.state.total,onChange:this.onPageChange }} loading={this.state.loading} scroll={{ x: this.state.totalWidth + 62 }}/>
                                    </Row>
                                :this.state.tab===6?
                                    <Row style={{maxWidth:this.state.totalWidth + 62,marginTop:20,}}>
                                        <Table rowKey={(record)=>record.cateitem_id} columns={this.columnsBiaodian} dataSource={data} pagination={{ pageSize: +this.state.pagesize,total:this.state.total,onChange:this.onPageChange }} loading={this.state.loading} scroll={{ x: this.state.totalWidth + 62 }}/>
                                    </Row>
                                :this.state.tab===7?
                                    <Row style={{maxWidth:this.state.totalWidth + 62,marginTop:20,}}>
                                        <Table  rowKey={(record)=>record.cateitem_id} columns={this.columnsCategoryLabel} dataSource={data} pagination={{ pageSize: +this.state.pagesize,total:this.state.total,onChange:this.onPageChange }} loading={this.state.loading} scroll={{ x: this.state.totalWidth + 62 }}/>
                                    </Row>
                                :''
                                    
                                    
                }
				<WrappedCreateLabelModalForm cateitemType={this.state.tab} openCreate={this.state.openCreate} handleClose={this.handleClose} />
				<WrappedDeleteLabelModalForm cateitemType={this.state.tab} openDelete={this.state.openDelete} handleClose={this.handleClose} />
				{this.state.editDialog&&<WrappedEditItemModalForm itemData={this.state.itemData} editDialog={this.state.editDialog} handleClose={this.handleClose}/>}
            </div>
        );
    }

}

function mapState(state) {	
    return {
        user:state.user
    };
}

function mapDispatch(dispatch) {
    return{
    }
}
export default connect(mapState, mapDispatch)(WordBank);


// WEBPACK FOOTER //
// ./src/entry_app/knowledge_assist/wordBank/view.js